export const siteInfo = {
  name: '打屁股游戏',
  tagline: '好玩有趣的互动小游戏合集',
  description: '打屁股游戏是一款深受玩家喜爱的互动休闲小游戏，融合趣味惩罚机制与欢乐互动玩法。本页汇集打屁股游戏的玩法介绍、规则说明、技巧攻略及同类推荐，让你快速上手，体验轻松欢乐的游戏时光。',
  keywords: '打屁股游戏,打屁股游戏玩法,打屁股互动游戏,趣味惩罚游戏,欢乐派对小游戏,休闲互动游戏,搞笑惩罚游戏,手机趣味游戏',
  url: 'https://dapiguyouxi.com',
  email: 'hello@dapiguyouxi.com',
  about: {
    intro: '打屁股游戏是一个专注于趣味互动小游戏的平台，我们致力于为玩家提供最新、最全、最有趣的打屁股游戏资讯、攻略和推荐。无论你是派对达人、情侣玩家还是亲子家庭，都能在这里找到适合自己的游戏玩法。',
    story: '我们的团队由一群热爱游戏、热爱生活的年轻人组成。我们发现打屁股游戏作为一种轻松有趣的互动方式，能够让人与人之间的关系更加亲密，让聚会更加欢乐。于是我们创建了这个平台，希望让更多人了解并享受这类游戏的乐趣。',
    reputation: [
      {
        name: '小明',
        role: '游戏玩家',
        content: '这个网站帮我找到了好多好玩的派对游戏！上次朋友聚会用了推荐的真心话大冒险打屁股版，气氛超级好！',
        rating: 5,
      },
      {
        name: '小红',
        role: '派对达人',
        content: '分类很清晰，找游戏很方便。特别是情侣互动板块，我和男朋友玩得很开心，推荐！',
        rating: 5,
      },
      {
        name: '小李',
        role: '团队负责人',
        content: '团建的时候用了网站上推荐的游戏方案，效果特别好，同事们都说比以前的团建有趣多了！',
        rating: 4,
      },
      {
        name: '张妈妈',
        role: '家长用户',
        content: '亲子游戏板块内容很用心，和孩子一起玩数字游戏，既学知识又开心，非常推荐给家长们。',
        rating: 5,
      },
    ],
    contact: {
      email: 'hello@dapiguyouxi.com',
      wechat: 'dapiguyouxi',
      qq: '1234567890',
    },
  },
};